var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAlertTriangleBold = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / warning_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.945312 21L11.3489 2L21.7525 21H0.945312ZM4.20826 19H18.4896L11.3489 6L4.20826 19ZM11.3489 18C11.6169 18 11.8417 17.904 12.0233 17.712C12.2042 17.5207 12.2947 17.2833 12.2947 17C12.2947 16.7167 12.2042 16.4793 12.0233 16.288C11.8417 16.096 11.6169 16 11.3489 16C11.081 16 10.8565 16.096 10.6755 16.288C10.4939 16.4793 10.4031 16.7167 10.4031 17C10.4031 17.2833 10.4939 17.5207 10.6755 17.712C10.8565 17.904 11.081 18 11.3489 18ZM10.4031 15H12.2947V10H10.4031V15Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlertTriangleBold, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AlertTriangleBold.f7375bf1.svg";
export { ForwardRef as ReactComponent };